import Component from '@glimmer/component';
import dateUtils from 'donor-elf-web/lib/date-utils';
import { type PropertyFilterInfo } from 'donor-elf-web/lib/filter-utils-new';

interface ComponentArgs {
  selectedPropertyFilterInfo: PropertyFilterInfo;
  changeset: any;
  showValidationErrors: boolean;
}

export default class FilterEditDateBetweenComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    let { changeset } = this.args;
    // have to update the changeset in the next runloop
    setTimeout(() => {
      let vals = changeset.get('val') || ([] as string[]);
      changeset.set('dateBetweenAfterVal', vals[0]);
      changeset.set('dateBetweenBeforeVal', vals[1]);
    });
  }

  serializeDateChange = (propertyName: string, val: any) => {
    if (val && typeof val === 'object' && typeof val.getDate === 'function') {
      let serializedVal = dateUtils.serializeToDateOnly(val);
      this.args.changeset.set(propertyName, serializedVal);
    }
  }
}
